/** Operators (and admins) work in the back-office; members live in workspaces. */
export function isOperator(role) {
    return role === 'admin' || role === 'operator';
}
/**
 * A partner creates companies and invites their people, and nothing else.
 *
 * It is a third side, not a smaller back-office: `isOperator` is false for it
 * on purpose, and what it may reach is listed route by route under
 * `/api/partner`, never derived from what an operator may.
 */
export function isPartner(role) {
    return role === 'partner';
}
